@if (appliedChips.length && chipsVisible) {
<div class="filters-summary">
  <span class="label">Filtros:</span>
  @for (chip of appliedChips; track chip) {
  <nz-tag nzMode="closeable" (nzOnClose)="removeChip(chip)">
    {{ chip.text }}
  </nz-tag>
  }
  <button type="button" nz-button nzType="link" class="clear-all" (click)="clearAdvancedFilters()">Limpiar todos</button>
</div>
}

<nz-drawer
  class="filters-drawer"
  [nzVisible]="visible"
  (nzOnClose)="close.emit()"
  nzPlacement="right"
  [nzWidth]="420"
  [nzTitle]="drawerTitle"
  [nzFooter]="filtersFooter"
  [nzMaskClosable]="false"
>
  <ng-container *nzDrawerContent>
    <form nz-form [formGroup]="filtersForm" nzLayout="vertical" class="fd-form">
      @if (sections.basic) { @if (isVisible('name')) {
      <nz-form-item>
        <nz-form-label>Nombre del Catálogo</nz-form-label>
        <nz-form-control><input nz-input formControlName="name" placeholder="Buscar por nombre" /></nz-form-control>
      </nz-form-item>
      } @if (isVisible('providers')) {
      <nz-form-item>
        <nz-form-label>Proveedor</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="providers" nzMode="multiple" nzPlaceHolder="Seleccione proveedores">
            @for (p of providerOptions; track p) {
            <nz-option [nzLabel]="p" [nzValue]="p"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      } @if (isVisible('rates')) {
      <nz-form-item>
        <nz-form-label>Tarifa</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="rates" nzMode="multiple" nzPlaceHolder="Seleccione tarifas">
            @for (r of rateOptions; track r) {
            <nz-option [nzLabel]="r" [nzValue]="r"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      } @if (isVisible('statuses')) {
      <nz-form-item>
        <nz-form-label>Estado</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="statuses" nzMode="multiple" nzPlaceHolder="Seleccione estados">
            @for (s of statusOptions; track s) {
            <nz-option [nzLabel]="stateLabel(s)" [nzValue]="s"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      } @if (isVisible('typeCatalogs')) {
      <nz-form-item>
        <nz-form-label>Tipo de catálogo</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="catalogTypes" nzMode="multiple" nzPlaceHolder="Seleccione estados">
            @for (s of catalogTypesOptions; track s) {
            <nz-option [nzLabel]="stateCatalogTypesLabel(s)" [nzValue]="s"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      } } @if (sections.dates) {
      <div class="fd-heading">Rangos de Fechas</div>
      @if (isVisible('creationRange')) {
      <nz-form-item>
        <nz-form-label>Fecha de Creación</nz-form-label>
        <nz-form-control><nz-range-picker formControlName="creationRange" nzFormat="yyyy-MM-dd" [nzSeparator]="'—'"></nz-range-picker></nz-form-control>
      </nz-form-item>
      } @if (isVisible('receptionRange')) {
      <nz-form-item>
        <nz-form-label>Fecha de Recepción</nz-form-label>
        <nz-form-control><nz-range-picker formControlName="receptionRange" nzFormat="yyyy-MM-dd" [nzSeparator]="'—'"></nz-range-picker></nz-form-control>
      </nz-form-item>
      } @if (isVisible('effectiveRange')) {
      <nz-form-item>
        <nz-form-label>Fecha de Entrada en Vigor</nz-form-label>
        <nz-form-control><nz-range-picker formControlName="effectiveRange" nzFormat="yyyy-MM-dd" [nzSeparator]="'—'"></nz-range-picker></nz-form-control>
      </nz-form-item>
      } @if (isVisible('publicationRange')) {
      <nz-form-item>
        <nz-form-label>Fecha de Publicación</nz-form-label>
        <nz-form-control><nz-range-picker formControlName="publicationRange" nzFormat="yyyy-MM-dd" [nzSeparator]="'—'"></nz-range-picker></nz-form-control>
      </nz-form-item>
      } }
    </form>
  </ng-container>

  <ng-template #filtersFooter>
    <div class="fd-footer">
      <button type="button" nz-button class="fd-ghost" (click)="clearAdvancedFilters()">
        <i nz-icon nzType="delete" style="top: -3px; position: relative"></i><span>Limpiar Filtros</span>
      </button>
      &nbsp;
      <button type="button" nz-button nzType="primary" class="fd-apply" (click)="applyAdvancedFilters()">
        <i nz-icon nzType="check" style="top: -3px; position: relative"></i><span>Aplicar Filtros</span>
      </button>
    </div>
  </ng-template>
</nz-drawer>
